import { Form, FormSubmit } from "@ariakit/react";
import { LetterheadTextField, useForm } from "@indietabletop/appkit";
import { button } from "../common.css";
import { database } from "../database/database";
import {
  DialogContent,
  DialogHeader,
  ScrollableDialog,
} from "../Dialog/Dialog";
import { useHandleSuccess } from "../KnightlyOrdersPage/useHandleSuccess";
import { useWarbandContext } from "./useWarbandContext";

export function EditWarbandDialog() {
  const warband = useWarbandContext();
  const handleSuccess = useHandleSuccess();
  const { form } = useForm({
    defaultValues: { name: warband.data.name },
    async onSubmit({ values }) {
      const next = warband.clone({ name: values.name });
      return await database.warbands.updateOne(next.data);
    },
    onSuccess() {
      handleSuccess({ message: "Saved!" });
    },
  });

  return (
    <ScrollableDialog>
      <Form store={form} autoComplete="off" noValidate resetOnSubmit={false}>
        <DialogHeader heading="Edit warband" />

        <DialogContent
          style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}
        >
          <LetterheadTextField
            name={form.names.name}
            label="Name"
            autoFocus
            placeholder="E.g. Vanguard of the Silver Chalice"
            data-1p-ignore="true"
          />

          <div
            style={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}
          >
            <FormSubmit className={button()}>Save</FormSubmit>
          </div>
        </DialogContent>
      </Form>
    </ScrollableDialog>
  );
}
